export default __webpack_public_path__ + "static/media/Notif - Community Update.4ee8a26f.svg";